
/* injects from baggage-loader */

'use strict';

import CheckMailingInstructionsModalController from './checkmailinginstructionsmodal.controller';
import CheckMailingInstructionsModalTemplate from './checkmailinginstructionsmodal.html';

export default class CheckMailingInstructionsModalComponent {
		constructor() {
				this.templateUrl = CheckMailingInstructionsModalTemplate;
				this.controller = CheckMailingInstructionsModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}
